import { ProgressIndicator } from "@veneer/core";

const LoadingModal = () => {
  return (
    <div className="modal-content">
      <div className="modal-loading">
        <ProgressIndicator appearance="circular" behavior="indeterminate" />
      </div>
    </div>
  );
};

export default LoadingModal;
